import ReactGA from 'react-ga';
import get from 'lodash/get';
import getBasePath from 'bento-ordering/utils/getBasePath';

import { GOOGLE_ANALYTICS } from 'bento-ordering/base/constants/tracking';

export const initializeTracking = () => (dispatch, getState) => {
  dispatch(initializeGA());
};

export const initializeGA = () => (dispatch, getState) => {
  const state = getState();
  const account = state.account;
  const googleAnalyticsCode = get(
    account,
    'google_analytics.tracking_code',
    ''
  );

  if (googleAnalyticsCode) {
    ReactGA.initialize(googleAnalyticsCode);
    dispatch({ type: GOOGLE_ANALYTICS });
  }
};

export const trackPageview = (pageTitle = '') => (dispatch, getState) => {
  const state = getState();
  const router = state.router;
  const { gaInitialized } = state.tracking;
  const path = router.location.pathname;

  // trackPageview takes params "url" and "title" (not named arguments)
  // BentoAnalytics will ignore arguments if they are blank strings
  // https://github.com/getbento/analytics
  if (window.BentoAnalytics) {
    window.BentoAnalytics.trackPageview('', pageTitle);
  }

  if (gaInitialized) {
    trackGAPageView(path);
  }
};

export const trackAddToCart = quantity => (dispatch, getState) => {
  const state = getState();
  const { gaInitialized } = state.tracking;

  if (window.BentoAnalytics) {
    window.BentoAnalytics.trackEvent('Add to Cart', 'Click', 'eCom', quantity);
  }

  if (gaInitialized) {
    trackGAEvent('Add to Cart', 'Click', 'eCom', quantity);
  }
};

export const trackGAPageView = path => {
  // page view path needs to include base path
  path = `${getBasePath()}${path}`;
  ReactGA.ga('send', 'pageview', path);
};

export const trackGAEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};
